// 会员等级图片 下标代表当前等级

export interface VipOptionsV2 {
  background: string;
  sign: string;
  progressLinear: string;
  titleClass: string;
  curTextClass?: string;
  small: string;
}

export type WeeklyCardType = 'silver' | 'gold' | 'diamond';

// 会员等级样式配置V2
const baseVipOptionsV2: VipOptionsV2[] = [
  {
    background: require('@/assets/imgs/vip/v2/bg/v0.webp'),
    sign: require('@/assets/imgs/vip/v2/sign/v0.webp'),
    progressLinear: 'linear-gradient(90deg, #86B8D1 0%, #61B0D9 100%)',
    titleClass: 'text-[#475963]',
    curTextClass: 'text-[#617886]',
    small: require('@/assets/imgs/vip/v2/small/v0.webp'),
  },
  {
    background: require('@/assets/imgs/vip/v2/bg/v1.webp'),
    sign: require('@/assets/imgs/vip/v2/sign/v1.webp'),
    progressLinear: 'linear-gradient(90deg, #79EACB 0%, #34E3B3 100%)',
    titleClass: 'text-[#235D43]',
    curTextClass: 'text-[#416856]',
    small: require('@/assets/imgs/vip/v2/small/v1.webp'),
  },
  {
    background: require('@/assets/imgs/vip/v2/bg/v2.webp'),
    sign: require('@/assets/imgs/vip/v2/sign/v2.webp'),
    progressLinear: 'linear-gradient(90deg, #7A98F4 0%, #3486E3 100%)',
    titleClass: 'text-[#213B68]',
    curTextClass: 'text-[#2D4368]',
    small: require('@/assets/imgs/vip/v2/small/v2.webp'),
  },
  {
    background: require('@/assets/imgs/vip/v2/bg/v3.webp'),
    sign: require('@/assets/imgs/vip/v2/sign/v3.webp'),
    progressLinear: 'linear-gradient(90deg, #79B2EA 0%, #34C6E3 100%)',
    titleClass: 'text-[#0E6078]',
    small: require('@/assets/imgs/vip/v2/small/v3.webp'),
  },
  {
    background: require('@/assets/imgs/vip/v2/bg/v4.webp'),
    sign: require('@/assets/imgs/vip/v2/sign/v4.webp'),
    progressLinear: 'linear-gradient(90deg, #F4A437 0%, #FFBB0E 100%)',
    titleClass: 'text-[#805511]',
    small: require('@/assets/imgs/vip/v2/small/v4.webp'),
  },
  {
    background: require('@/assets/imgs/vip/v2/bg/v5.webp'),
    sign: require('@/assets/imgs/vip/v2/sign/v5.webp'),
    progressLinear: 'linear-gradient(90deg, #F7A570 0%, #FA8731 100%)',
    titleClass: 'text-[#91420E]',
    small: require('@/assets/imgs/vip/v2/small/v5.webp'),
  },
  {
    background: require('@/assets/imgs/vip/v2/bg/v6.webp'),
    sign: require('@/assets/imgs/vip/v2/sign/v6.webp'),
    progressLinear: 'linear-gradient(90deg, #F2676A 0%, #FC4F53 100%)',
    titleClass: 'text-[#830D14]',
    small: require('@/assets/imgs/vip/v2/small/v6.webp'),
  },
  {
    background: require('@/assets/imgs/vip/v2/bg/v7.webp'),
    sign: require('@/assets/imgs/vip/v2/sign/v7.webp'),
    progressLinear: 'linear-gradient(90deg, #F7CE64 0%, #FFC221 100%)',
    titleClass: 'text-[#5B4407]',
    small: require('@/assets/imgs/vip/v2/small/v7.webp'),
  },
  {
    background: require('@/assets/imgs/vip/v2/bg/v8.webp'),
    sign: require('@/assets/imgs/vip/v2/sign/v8.webp'),
    progressLinear: 'linear-gradient(90deg, #FCA207 0%, #FFAB10 100%)',
    titleClass: 'text-[#713C00]',
    small: require('@/assets/imgs/vip/v2/small/v8.webp'),
  },
  {
    background: require('@/assets/imgs/vip/v2/bg/v9.webp'),
    sign: require('@/assets/imgs/vip/v2/sign/v9.webp'),
    progressLinear: 'linear-gradient(90deg, #07FC07 0%, #84FF10 100%)',
    titleClass: 'text-[#1B5C05]',
    small: require('@/assets/imgs/vip/v2/small/v9.webp'),
  },
  {
    background: require('@/assets/imgs/vip/v2/bg/v10.webp'),
    sign: require('@/assets/imgs/vip/v2/sign/v10.webp'),
    progressLinear: 'linear-gradient(90deg, #30B8FF 0%, #C059FF 100%)',
    titleClass: 'text-[#0C4E6B]',
    curTextClass: 'text-[#10516D]',
    small: require('@/assets/imgs/vip/v2/small/v10.webp'),
  },
  {
    background: require('@/assets/imgs/vip/v2/bg/v11.webp'),
    sign: require('@/assets/imgs/vip/v2/sign/v11.webp'),
    progressLinear: 'linear-gradient(90deg, #EB43FF 0%, #FF3B3D 100%)',
    titleClass: 'text-[#56152B]',
    small: require('@/assets/imgs/vip/v2/small/v11.webp'),
  },
  {
    background: require('@/assets/imgs/vip/v2/bg/v12.webp'),
    sign: require('@/assets/imgs/vip/v2/sign/v12.webp'),
    progressLinear: 'linear-gradient(90deg, #FF4380 0%, #FF0099 100%)',
    titleClass: 'text-[#71021C]',
    small: require('@/assets/imgs/vip/v2/small/v12.webp'),
  },
  {
    background: require('@/assets/imgs/vip/v2/bg/v13.webp'),
    sign: require('@/assets/imgs/vip/v2/sign/v13.webp'),
    progressLinear: 'linear-gradient(90deg, #A6A9D2 0%, #A5A8CD 100%)',
    titleClass: 'text-[#FCFBFF]',
    small: require('@/assets/imgs/vip/v2/small/v13.webp'),
  },
  {
    background: require('@/assets/imgs/vip/v2/bg/v14.webp'),
    sign: require('@/assets/imgs/vip/v2/sign/v14.webp'),
    progressLinear: 'linear-gradient(90deg, #FED37D 0%, #FFC861 100%)',
    titleClass:
      'bg-gradient-to-r from-[#F9F7F0] via-[#FEFB7A] to-[#FFF] bg-clip-text text-transparent',
    curTextClass: 'text-[#FFF]',
    small: require('@/assets/imgs/vip/v2/small/v14.webp'),
  },
  {
    background: require('@/assets/imgs/vip/v2/bg/v15.webp'),
    sign: require('@/assets/imgs/vip/v2/sign/v15.webp'),
    progressLinear: 'linear-gradient(90deg, #AFA2FF 0%, #D08EFF 100%)',
    titleClass:
      'bg-gradient-to-r from-[#F9F7F0] via-[#FEFB7A] to-[#FFF] bg-clip-text text-transparent',
    curTextClass: 'text-[#FFF]',
    small: require('@/assets/imgs/vip/v2/small/v15.webp'),
  },
];

export const vipOptionsV2 = baseVipOptionsV2.map(item => ({
  ...item,
  curTextClass: item.curTextClass || item.titleClass,
}));
